import React from 'react'
import { NavLink } from 'react-router-dom'
import { analytics, constants } from 'helpers'

const {
  ROUTES: { PROFILE, SETTINGS },
} = constants

const Link = ({ to, text }) => {
  const handleClick = () => {
    analytics.segmentTrack(`User Clicked On ${text} Button`)
  }

  return (
    <NavLink
      to={to}
      onClick={handleClick}
      className="bg-transparent text-base font-medium mr-4 text-gray-400 hover:opacity-80 focus:outline-0"
      activeStyle={{
        textDecoration: 'underline',
        color: 'white',
      }}
    >
      {text}
    </NavLink>
  )
}

const ProfileToggle = ({ user }) => (
  <div className="hidden absolute right-2 top-4 font-tomatoGrotesk z-5 md:block md:right-8 md:top-11">
    <div className="rounded-lg flex justify-between overflow-hidden border-opacity-60">
      <Link to={PROFILE} text="Profile" user={user} />
      <Link to={SETTINGS} text="Account" user={user} />
    </div>
  </div>
)

export default ProfileToggle
